/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

import isNil from 'lodash/isNil';

/**
 * Nahrazovač nastavení obrazovky zařízení
 *
 * Stará se o aktualizaci orientace zařízení dle obsahu datového skladu.
 */
class ReplacerScreen {
  /**
   * Vytvoří instanci.
   * @param {OrientationEnum} defaultOrientationEnum
   * @param {ScreenManager} screenManager
   */
  constructor(defaultOrientationEnum, screenManager) {
    this.defaultOrientationEnum = defaultOrientationEnum;
    this.screenManager = screenManager;
  }

  /**
   * Zjistí orientaci i pro případy, že v obsahu není definovaná.
   * @param {OrientationEnum} [orientationEnum] Orientace z obsahu.
   * @private
   * @returns {OrientationEnum} Vždy definovaná orientace.
   */
  getOrientation(orientationEnum) {
    if (isNil(orientationEnum)) {
      // Pokud není žádná preferovaná orientace dostupná (např. u nového zařízení),
      // tak se použije výchozí hodnota.
      return this.defaultOrientationEnum;
    }
    return orientationEnum;
  }

  /**
   * Změní nastavení obrazovky dle obsahu.
   * @param {ContentInfo} contentInfo
   * @returns {Promise.<undefined>}
   */
  replace(contentInfo) {
    return new Promise((resolve) =>
      resolve(
        this.screenManager.setOrientation(
          this.getOrientation(contentInfo.session.orientationEnum)
        )
      )
    );
  }
}

export default ReplacerScreen;
